<template>
  <div class="ask mb-2">
            <span class="ask__icon">
              <img class="ask__image" rel="preload" alt="profile icon" :src="getIcon()"/>
            </span>
    <span class="ask__title heading-h6-14-medium">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "AskHeading",
  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      iconProfile: require("@/core/assets/new-dashboard/onboard/icon-profile.svg"),
      iconTellUs: require("@/core/assets/new-dashboard/onboard/icon-tellus.svg"),
    }
  },
  methods: {
    getIcon() {
      if (this.icon === "profile") {
        return this.iconProfile;
      } else if (this.icon === "tellus") {
        return this.iconTellUs;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ask {
  display: flex;
  justify-items: baseline;

  &__icon {
    margin-right: 10px;
    display: flex;
    align-content: baseline;
  }

  &__image {
    width: 18px;
  }

  &__title {

  }
}
</style>
